import { Component, OnInit } from '@angular/core';
import { environment } from '@env/environment';

@Component({
  selector: 'app-header-empty',
  templateUrl: './header-empty.component.html',
  styleUrls: ['./header-empty.component.scss'],
})
export class HeaderEmptyComponent implements OnInit {
  public logoPath = environment.defaultLogoUrl;

  constructor() {}

  ngOnInit() {}
}
